/**
 * Values that must stay identical to the current app (legacy index.html),
 * because existing users' saved data depends on them.
 */

/** Main localStorage key of the current app. Never rename. */
export const LEGACY_KEY = "hachi-garage-v1";

/** Every localStorage key the current app writes (main key + suffixes). Used by the Phase 4 import. */
export const LEGACY_KEYS = {
  state: LEGACY_KEY,
  sync: `${LEGACY_KEY}-sync`,
  device: `${LEGACY_KEY}-device`,
  session: `${LEGACY_KEY}-session`,
  pkce: `${LEGACY_KEY}-pkce`,
  cloud: `${LEGACY_KEY}-cloud`,
  store: `${LEGACY_KEY}-store`,
  geo: `${LEGACY_KEY}-geo`,
  restorePoints: `${LEGACY_KEY}-restore-points`,
  lastView: `${LEGACY_KEY}-last-view`,
  schedView: `${LEGACY_KEY}-sched-view`,
  by: `${LEGACY_KEY}-by`,
} as const;

/** Kilometres in a mile. Distances are always stored in km. */
export const KM_PER_MILE = 1.609344;

/** Litres per volume unit. */
export const LITRES_PER = { L: 1, USgal: 3.785411784, UKgal: 4.54609 } as const;
export type VolumeUnit = keyof typeof LITRES_PER;

/** Fuel economy units and their labels. */
export const ECONOMY_LABELS = { "km/L": "km/L", "L/100km": "L/100 km", mpgUS: "mpg (US)", mpgUK: "mpg (UK)" } as const;
export type EconomyUnit = keyof typeof ECONOMY_LABELS;

export type DistanceUnit = "km" | "mi";
export type ThemeChoice = "system" | "light" | "dark";
